import { DefaultPageState } from "../../../common/models/StoreDefaultModel";

export type ChalandMaterialItemData = {};

export const initialChalandMaterialPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
